'use client';

import { HTMLAttributes, forwardRef } from 'react';

import { cn } from '@/lib/css-utils';

export type CardContainerProps = HTMLAttributes<HTMLDivElement> & {
    className?: string;
};

export const CardContainer = forwardRef<HTMLDivElement, CardContainerProps>(
    ({ className, children, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(
                    'flex flex-col w-full bg-neutral-950 border border-neutral-800 shadow-md rounded-lg p-4',
                    className
                )}
                {...props} // 👈 passes through onClick, id, etc.
            >
                {children}
            </div>
        );
    }
);

CardContainer.displayName = 'CardContainer';
